import React, { useEffect, useState } from 'react'
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import './globalStyles.css'
import './swimlane.css'
import { withTheme } from 'theming'
import { isEmpty, shuffle } from 'lodash'
import useTemplateHook from '../templateHook'
import EditMenu from '../editMenu'
import useAxios from 'axios-hooks'
import AddSection from '../addSection'
import ArtistCard from '../../contentCard/artistCard'
import { useTranslation } from 'react-i18next'

const DefaultArtistSwimlane = ({
  componentData,
  modifyData,
  setModalState,
  isEdit = true,
  onDelete,
  theme,
  onAdd,
  onSwap,
}) => {
  //   const { data, title, filters, seeMoreVisible, type, theme } = props
  const { t } = useTranslation()
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const { customNavigate, isBrowser, LG_SIZE, SM_SIZE, ARTIST_LISTING } = useTemplateHook()
  const [visibleSlides, setVisibleSlides] = useState(2)
  const [artistData, setArtistData] = useState([])
  const language = localStorage.getItem('language') || 'en'

  const [{ data: artistList }, artistListCall] = useAxios(
    {
      url: ARTIST_LISTING,
      method: 'get',
    },
    { manual: true },
  )

  const handleResize = () => {
    if (window.innerWidth >= LG_SIZE) {
      setVisibleSlides(5)
    } else if (window.innerWidth < LG_SIZE && window.innerWidth >= SM_SIZE) {
      setVisibleSlides(3)
    } else {
      setVisibleSlides(2)
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    artistListCall({
      params: {
        page_size: 15,
        page: 1,
        order_by: data?.order_by === 'title' ? `title.${language}` : data?.order_by,
        reverse: data?.reverse,
      },
    })
  }, [])

  useEffect(() => {
    if (artistList && artistList?.success) {
      setArtistData(shuffle(artistList?.data))
    }
  }, [artistList])

  const handleSeeMore = () => {
    customNavigate('DIRECT', `/artists`, isEdit)
    // let filters =
    //   data.type === 'STATIC'
    //     ? {
    //         content_id: data.content_data,
    //       }
    //     : {
    //         system_defined: data.auto_payload.filter((info) => info.type === 'system_defined'),
    //         custom_defined: data.auto_payload.filter((info) => info.type === 'custom_defined'),
    //       }
    // const encoded = encodeURI(JSON.stringify(filters))
    // customNavigate(
    //   'DIRECT',
    //   `/content/filter/${createSlug(data.name)}?filters=${encoded}&${
    //     data.type === 'STATIC' ? '' : 'filterV2=true'
    //   }`,
    //   isEdit,
    // )
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  return (
    <div
      className={`${
        isEdit && hoverState && 'component-hover-class'
      }  relative mt-6 md:mt-4 lg:mt-20 xl:mt-16 2xl:mt-24 pb-8 lg:pb-20  `}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
      style={{
        zIndex: 0,
      }}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onEdit={() => handleModal()}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
        />
      )}
      <div
        style={{ backgroundColor: theme.c1, padding: '0 5.52%' }}
        className="flex items-baseline"
      >
        <p style={{ color: theme.c3 }} className="sm:text-[0.8rem] md:text-[1.5rem] font-bold ">
          {data?.name}
        </p>
        {artistData.length > 14 && (
          <p
            style={{ cursor: 'pointer' }}
            className={
              'text-blue-400 text-xs md:text-md  ml-[4px] cursor-pointer hover:opacity z-30 mt-3'
            }
            onClick={handleSeeMore}
          >
            {t('see_more')}
          </p>
        )}
      </div>
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={100}
        totalSlides={artistData.length}
        visibleSlides={visibleSlides}
        step={5}
      >
        <div
          className={
            isEmpty(artistData)
              ? 'animate-pulse swimlane-container-dock h-[8.5rem] md:h-60 lg:h-[14rem]'
              : 'swimlane-container-dock h-[14rem] md:h-[24rem] 2xl:h-[24rem] xl:h-[20rem] lg:h-[25rem] '
          }
          style={{ backgroundColor: theme.c1 }}
        >
          <Slider className="slide-for-artists">
            {artistData.map((item, index) => {
              return (
                <Slide key={index} index={index} className="">
                  <div className="pt-2 md:pt-4 lg:pt-8 xl:pt-10">
                    <ArtistCard item={item} isEdit={isEdit} />
                  </div>
                </Slide>
              )
            })}
          </Slider>
          {isBrowser && (
            <>
              {artistData.length > visibleSlides ? (
                <ButtonBack>
                  <IoIosArrowBack className="left-Swimlane-arrow " />
                </ButtonBack>
              ) : null}
              {artistData.length > visibleSlides ? (
                <ButtonNext>
                  <IoIosArrowForward className="right-Swimlane-arrow " />
                </ButtonNext>
              ) : null}
            </>
          )}
        </div>
      </CarouselProvider>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(DefaultArtistSwimlane)
